import axiosClient from '../axiosClient';
import { User } from '../../types/common';

export interface GoogleAuthRequest {
  credential: string; // Google JWT token
}

export interface FacebookAuthRequest {
  accessToken: string;
  userID: string;
}

export interface SocialAuthResponse {
  user: User;
  token: string;
}

export const authApi = {
  // Google OAuth login/signup
  googleAuth: async (data: GoogleAuthRequest): Promise<SocialAuthResponse> => {
    const response = await axiosClient.post('/auth/google', data);
    return response.data;
  },

  // Facebook OAuth login/signup
  facebookAuth: async (data: FacebookAuthRequest): Promise<SocialAuthResponse> => {
    const response = await axiosClient.post('/auth/facebook', data);
    return response.data;
  },
};
